import { render } from "./BaseIconIsActive.vue?vue&type=template&id=e216836c"
import script from "./BaseIconIsActive.vue?vue&type=script&lang=js"
export * from "./BaseIconIsActive.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__